export enum UpgradeScenario {
  MonthlyStarterToDesignStarter = "monthly_starter_to_design_starter",
  MonthlyEssentialToDesignStarter = "monthly_essential_to_design_starter",
  MonthlyPremiumToDesignPro = "monthly_premium_to_design_pro",
  YearlyPremiumToDesignPro = "yearly_premium_to_design_pro",
  YearlyEssentialToDesignStarter = "yearly_essential_to_design_starter",
  YearlyStarterToDesignStarter = "yearly_starter_to_design_starter",
  MonthlyFoundationalToPhotoshootStarter = "monthly_foundational_to_photoshoot_starter",
  YearlyFoundationalToPhotoshootStarter = "yearly_foundational_to_photoshoot_starter",
  YearlyPrestigeToCreativeSuite = "yearly_prestige_to_creative_suite",
}

export interface PlanInfo {
  name: string;
  price: string;
  billingCycle: "monthly" | "yearly";
}

export interface UpgradeFeature {
  label: string;
  description: string;
}

export interface YearlyPriceBreakdown {
  fullPrice: string;
  discountAmount: string;
  discountPercentage: number;
  finalPrice: string;
  monthlyEquivalent: string;
  savingsNote: string;
}

export interface UpgradeScenarioConfig {
  id: UpgradeScenario;
  oldPlan: PlanInfo;
  newPlan: PlanInfo;
  features: UpgradeFeature[];
  yearlyBreakdown?: YearlyPriceBreakdown;
}

export interface PackageUpgradeModalProps {
  show: boolean;
  onClose: () => void;
  scenario: UpgradeScenarioConfig;
}
